<template>
  <div class="xcard">
    <h4 class="text-primary text-center">Menu de Proyectos</h4>

    <v-row>
      <v-col>
        <v-btn @click="$router.push(`proyectoshabilitacion`)">Habilitacion de proyectos</v-btn>
      </v-col>
      <v-col>
        <v-btn @click="$router.push(`proyectosentrega`)">Entrega de proyectos</v-btn>
      </v-col>
      <v-col>
        <v-btn @click="$router.push(`proyectoslistado`)">Listado de proyectos</v-btn>
      </v-col>
      <v-col>
        <v-btn @click="$router.push(`proyectosconsolidar`)">Consolidar proyectos</v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  export default {
    data() {
      return {};
    },
    methods: {},
    mounted() {},
  };
</script>
